<template>
  <div class="step-form step-form--centered">
    <h2 class="step-form__title">{{ $t(stepKey + '.title') }}</h2>
    <p class="step-form__subtitle">{{ $t(stepKey + '.subtitle') }}</p>

    <div class="bool-options">
      <button
        class="bool-card"
        :class="{ 'bool-card--selected': formData[field] === true }"
        @click="select(true)"
      >
        <div class="bool-card__icon bool-card__icon--yes">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>
        </div>
        <span class="bool-card__label">{{ $t(stepKey + '.yes') }}</span>
      </button>

      <button
        class="bool-card"
        :class="{ 'bool-card--selected bool-card--no': formData[field] === false }"
        @click="select(false)"
      >
        <div class="bool-card__icon bool-card__icon--no">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </div>
        <span class="bool-card__label">{{ $t(stepKey + '.no') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BooleanStep',
  props: {
    formData: Object,
    stepKey: String,
    field: String,
  },
  methods: {
    select(value) {
      this.$emit('update', { [this.field]: value })
    },
  },
}
</script>

<style lang="scss" scoped>
.step-form {
  &--centered { text-align: center; }

  &__title {
    font-size: clamp(1.4rem, 3vw, 2rem);
    font-weight: 800;
    margin-bottom: 0.4rem;
    background: linear-gradient(135deg, #fff 30%, var(--gold-light));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__subtitle {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 2.5rem;
  }
}

.bool-options {
  display: flex;
  gap: 16px;
  justify-content: center;

  @media (max-width: 400px) { flex-direction: column; align-items: center; }
}

.bool-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 48px;
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: all 0.25s;
  min-width: 160px;

  &:hover {
    border-color: rgba(208, 176, 146, 0.2);
    background: rgba(208, 176, 146, 0.04);
    transform: translateY(-2px);
  }

  &--selected {
    border-color: var(--gold);
    background: rgba(208, 176, 146, 0.08);
    box-shadow: 0 8px 32px rgba(208, 176, 146, 0.15);
    color: var(--gold-light);
  }

  &--no.bool-card--selected {
    border-color: #ea5455;
    background: rgba(234, 84, 85, 0.08);
    box-shadow: 0 8px 32px rgba(234, 84, 85, 0.15);
    color: #ff9a9b;
  }

  &__icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    &--yes {
      background: rgba(40, 199, 111, 0.08);
      color: #28c76f;
    }

    &--no {
      background: rgba(234, 84, 85, 0.08);
      color: #ea5455;
    }
  }

  &--selected &__icon--yes {
    background: rgba(40, 199, 111, 0.15);
    box-shadow: 0 0 24px rgba(40, 199, 111, 0.2);
  }

  &--selected &__icon--no {
    background: rgba(234, 84, 85, 0.15);
    box-shadow: 0 0 24px rgba(234, 84, 85, 0.2);
  }

  &__label {
    font-size: 0.95rem;
    font-weight: 600;
  }
}
</style>
